module.exports = __webpack_public_path__ + "img/vipevent_active_icon@2x.8fc229f5.png";